import { useSnackbar as useNotiSnackbar } from 'notistack'

// import { CorrectToast, ErrorToast } from 'src/components/molecules'
// NOTE: ↑のimport方法にすると styled-components のエラーが起きるため以下のように相対パスで個別に読み込む
import { CorrectToast } from '../components/molecules/feedbacks/CorrectToast'
import { ErrorToast } from '../components/molecules/feedbacks/ErrorToast'

type BaseToastOptions = {
  /** 同じトーストを表示したとしても1つだけ表示する */
  preventDuplicate?: boolean
  /** カスタムアイコンを表示する */
  icon?: React.ReactNode
}

type StandardToastOptions = BaseToastOptions & {
  /** 閉じるボタンを表示する */
  showCloseIcon?: boolean
}

const defaultStandardOptions: StandardToastOptions = {
  preventDuplicate: false,
  showCloseIcon: false,
  icon: undefined,
}

const defaultErrorOptions: BaseToastOptions = {
  preventDuplicate: false,
  icon: undefined,
}

export const useToast = () => {
  const { enqueueSnackbar } = useNotiSnackbar()

  const displayStandardTextToast = (
    text: string,
    options: StandardToastOptions = defaultStandardOptions
  ) => {
    enqueueSnackbar(text, {
      persist:
        options.showCloseIcon ?? false /* 閉じるボタンを表示する場合は自動的にトーストを隠さない */,
      preventDuplicate: options.preventDuplicate ?? false,
      content: (key, message) => {
        return (
          <CorrectToast
            id={key}
            text={message}
            icon={options.icon}
            showCloseIcon={options.showCloseIcon ?? false}
          />
        )
      },
    })
  }

  const displayErrorTextToast = (text: string, options: BaseToastOptions = defaultErrorOptions) => {
    enqueueSnackbar(text, {
      persist: true,
      preventDuplicate: options.preventDuplicate ?? false,
      content: (key, message) => {
        return <ErrorToast id={key} text={message} icon={options.icon} />
      },
    })
  }

  return { displayStandardTextToast, displayErrorTextToast }
}
